import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from "@mui/material";
import axios from 'axios';

export default function EditFacility() {
  const navigate = useNavigate();
  const { id } = useParams(); 
  const [formData, setFormData] = useState({
    facility_name: "",
    location: "",
    capacity: "",
    start_date: "",
    end_date: "",
    slots_timing: "",
    description: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
   
    const fetchFacility = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          alert("Authentication token is missing. Please log in again.");
          return;
        }

        const response = await axios.get(`https://api.nvcti.in/facilities/getFacilityById/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        if (response.status === 200) {
          const data = response.data.data;
  
          const formattedData = {
            ...data,
            slots_timing: data.slots_timing.replace(/"/g, ''), 
            start_date: data.start_date.split('T')[0],         
            end_date: data.end_date.split('T')[0]              
          };
  
          setFormData(formattedData);
        }
      } catch (error) {
        console.error("Error fetching facility data:", error);
        alert("Failed to fetch facility data. Please try again.");
      }
    };

    fetchFacility();
  }, [id]);

  // Form value handler
  function getFormValues(e) {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  // Validate the form data
  const validate = () => {
    let newErrors = {};
    if (!formData.facility_name) newErrors.facility_name = "Facility name is required";
    if (!formData.location) newErrors.location = "Location is required";
    if (!formData.capacity) newErrors.capacity = "Capacity is required";
    if (!formData.slots_timing) newErrors.slots_timing = "Slot timing is required";
    if (!formData.start_date) newErrors.start_date = "Start date is required";
    if (!formData.end_date) newErrors.end_date = "End date is required";
    if (!formData.description) newErrors.description = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const onSubmitFormData = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      if (!token) {
        alert("Authentication token is missing. Please log in again.");
        return;
      }

      const response = await axios.put(
        `https://api.nvcti.in/facilities/updateFacility/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.status === 200) {
        alert("Facility Updated Successfully!");
        navigate("/admin/facilites");
      }
    } catch (error) {
      console.error("Error updating facility:", error);
      alert("Failed to update facility. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center">
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 mt-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
        <div className="rounded-t bg-white mb-0 px-6 py-6">
          <div className="text-center flex justify-between">
            <h6 className="text-blueGray-700 text-xl font-bold">Edit Facility</h6>
          </div>
        </div>
        <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
          <form onSubmit={onSubmitFormData}>
            <h6 className="text-blueGray-400 text-1xl mt-3 mb-6 font-bold ">Facility Information</h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block text-blueGray-600 text-xs font-bold mb-2">Facility Name</label>
                  <input
                    placeholder="Facility Name"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="text"
                    name="facility_name"
                    value={formData.facility_name}
                    onChange={getFormValues}
                  />
                  {errors.facility_name && <p className="text-red-500 text-xs">{errors.facility_name}</p>}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block text-blueGray-600 text-xs font-bold mb-2">Location</label>
                  <input
                    placeholder="Location"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={getFormValues}
                  />
                  {errors.location && <p className="text-red-500 text-xs">{errors.location}</p>}
                </div>
              </div>
            </div>
            <hr className="mt-6 border-b-1 border-blueGray-300" />
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">Facility Schedule</h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block text-blueGray-600 text-xs font-bold mb-2">Capacity</label>
                  <input
                    placeholder="Capacity"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="text"
                    name="capacity"
                    value={formData.capacity}
                    onChange={getFormValues}
                  />
                  {errors.capacity && <p className="text-red-500 text-xs">{errors.capacity}</p>}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block text-blueGray-600 text-xs font-bold mb-2">Slot Timing</label>
                  <input
                    placeholder="Slot Timing"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="time"
                    name="slots_timing"
                    value={formData.slots_timing}
                    onChange={getFormValues}
                  />
                  {errors.slots_timing && <p className="text-red-500 text-xs">{errors.slots_timing}</p>}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block text-blueGray-600 text-xs font-bold mb-2">Start Date</label>
                  <input
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    name="start_date"
                    value={formData.start_date}
                    onChange={getFormValues}
                  />
                  {errors.start_date && <p className="text-red-500 text-xs">{errors.start_date}</p>}
                </div>
              </div>
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block text-blueGray-600 text-xs font-bold mb-2">End Date</label>
                  <input
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    type="date"
                    name="end_date"
                    value={formData.end_date}
                    onChange={getFormValues}
                  />
                  {errors.end_date && <p className="text-red-500 text-xs">{errors.end_date}</p>}
                </div>
              </div>
            </div>
            <hr className="mt-6 border-b-1 border-blueGray-300" />
            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold">Description</h6>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-12/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block text-blueGray-600 text-xs font-bold mb-2">Description</label>
                  <textarea
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Description"
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={getFormValues}
                  />
                  {errors.description && <p className="text-red-500 text-xs">{errors.description}</p>}
                </div>
              </div>
              <div className="flex justify-end w-full">
                <Tooltip title="Back" arrow>
                  <button
                    className="mt-10 text-white bg-blueGray-700 active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-auto ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => navigate("/admin/facilities")}
                  >
                    {"<< "}Back
                  </button>
                </Tooltip>
                <Tooltip title="Submit" arrow>
                  <button
                    className="bg-lightBlue-500 mt-10 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </Tooltip>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
